/** Background values that render as a light surface and get a neutral border on `cads-chip-button`. */
const _LIGHT_BORDER_BACKGROUNDS = new Set([
  'var(--cads-color-white)',
  'var(--cads-color-white-pastel)',
  'var(--cads-color-surface)',
  '#ffffff',
  '#fff',
  'white',
]);

/**
 * Returns **true** when the chip fill is white (or equivalent) so the component can apply a light-gray border.
 */
export function cadsChipButtonUsesLightBorder(backgroundColor: string | undefined): boolean {
  if (!backgroundColor?.trim()) {
    return false;
  }
  return _LIGHT_BORDER_BACKGROUNDS.has(backgroundColor.replace(/\s+/g, '').toLowerCase());
}
